// This file is automatically generated. Do not edit manually.

import { SitePartRevisionBomTreeViewResult } from "src/api/generated/erp/parts/sitePart/api/bom/sitePartRevisionBomTreeViewResult";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace SitePartRevisionBomTreeViewApi {
	export async function getTreeElements(args: {
		partRevisionId: number;
		showRevisions?: boolean;
		searchQuery?: string;
	}): Promise<SitePartRevisionBomTreeViewResult> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/parts/sitePart/bomTreeView/getTreeElements",
			method: "POST",
			data: {
				partRevisionId: args.partRevisionId,
				showRevisions: args.showRevisions,
				searchQuery: args.searchQuery,
			},
		});
		return response as SitePartRevisionBomTreeViewResult;
	}
}
